import React, { Component } from 'react';
import classNames from 'classnames';
import Paging from './common/Paging.react.js';
import MenuItemModal from './common/MenuItemModal.react.js'
let i18n = require("i18next");

export default class TableView extends Component {
    render() {
        return (
            <div id="table" className={classNames("state", "hidden", {experienceRestaurantDialogBottom : this.props.isExp})}>
                <div className="table-left sidebar">
                    <div className="table-level">
                        <span className="tableName"></span>
                        <span className="orderTime">15:02</span>
                    </div>

                    <div className="action-level">
                        <div className="orderAndSwitch">
                            <div className="toOrder action">
                                <div className="imgAndSpan">
                                    <div>
                                        <img src={require('../images/pos/toOrder.png')}/>
                                    </div>
                                    <span className="actionName">{i18n.t("pos.header.order")}</span>
                                </div>
                            </div>
                            <div className="switch-table action">
                                <div className="imgAndSpan">
                                    <div>
                                        <img src={require('../images/pos/cTable.png')}/>
                                    </div>
                                    <span className="actionName">{i18n.t("pos.label.table.switch")}</span>
                                </div>
                                <div className="activeBackgroundDiv"></div>
                            </div>
                        </div>
                        <div className="closeAndList">
                            <div className="close-table action">
                                <div className="imgAndSpan">
                                    <div>
                                        <img src={require('../images/pos/closeTable.png')}/>
                                    </div>
                                    <span className="actionName">{i18n.t("pos.label.table.close")}</span>
                                </div>
                            </div>
                            <div className="billList action">
                                <div className="imgAndSpan">
                                    <div>
                                        <img src={require('../images/pos/billList.png')}/>
                                    </div>
                                    <span className="actionName">{i18n.t("pos.table.item.billList")}</span>
                                </div>
                                <div className="activeBackgroundDiv"></div>
                            </div>
                        </div>
                    </div>

                    <div className="diner-level">
                        <span className="diner-count">{i18n.t("pos.printer.receipt.diner.total.count.label")}</span>
                        <span className="quantity-editor">
                            <buttom className="btn minus-btn v-m"></buttom>
                            <input type="text" className="quantity-input v-m" value="0" maxLength="2" size="2" disabled />
                            <buttom className="btn plus-btn v-mbtn plus-btn v-m"></buttom>
                        </span>
                    </div>

                    <div className="billlist-level">
                        <span className="billist-open"><span className="billCount"/> x {i18n.t("pos.bill.bills")}<img src={require("../images/pos/stretch.png")}/></span>
                    </div>

                    <div className="bill-level">
                        <div className="bill-status">{i18n.t("pos.bill.status.label")}</div>
                        <div className="bill-list">
                            <ul></ul>
                        </div>
                    </div>
                </div>

                <div className="table-right table-content"></div>

                <div className="table-right billListView hidden"></div>

                <MenuItemModal />

                <div className="modal webOrderModal">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">
                                    {i18n.t("pos.table.modal.billItems")}
                                </h4>
                                <button type="button" className="btn btn-close" data-dismiss="modal"
                                        style={{float: "right"}}></button>
                            </div>

                            <div className="modal-body">
                                <div>
                                    <div className="row"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/TableView.react.js